export var Actions = /*#__PURE__*/function (Actions) {
  Actions["GOTO_ITEM"] = "GOTO_ITEM";
  Actions["GO_BACK"] = "GO_BACK";
  return Actions;
}({});
export var goBack = function goBack() {
  return {
    type: Actions.GO_BACK
  };
};
export var gotoItem = function gotoItem(item) {
  return {
    type: Actions.GOTO_ITEM,
    payload: {
      item
    }
  };
};